/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FormAssignmentFile } from './FormAssignmentFile';
export type FormAssignmentAnswer = {
    content?: string | null;
    file?: FormAssignmentFile | null;
    fieldKey: string;
    type: FormAssignmentAnswer.type;
    label: string;
    required: boolean;
    sortOrder: number;
    textValue: string | null;
    numberValue: number | null;
};
export namespace FormAssignmentAnswer {
    export enum type {
        TEXT = 'text',
        TEXTAREA = 'textarea',
        NUMBER = 'number',
        FILE = 'file',
        SINGLE_CHOICE = 'single_choice',
        MULTIPLE_CHOICE = 'multiple_choice',
        INFO = 'info',
    }
}

